/* BioCare — shared behaviours: mobile nav + scroll reveal */
(function () {
  function initMenu() {
    document.querySelectorAll('[data-bc-burger]').forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var links = b.closest('.bc-nav').querySelector('.navlinks');
        if (links) links.classList.toggle('open');
      });
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { initMenu(); initReveal(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-run inside the Shopify theme editor when sections are added/reordered
  document.addEventListener('shopify:section:load', init);
})();